const Content = ({ children, classes = "" }: { children: JSX.Element[] | JSX.Element; classes?: string }) => {
  return <div className={`content ${classes}`}>{children}</div>;
};

export default Content;
